export default {
    DadosBancariosParaDebitos: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "dados-bancarios-para-debito"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/DadosBancariosParaDebitos.js
// module id = h04T
// module chunks = 32